//контакты

$(document).ready(function () {
	if (typeof ymaps != 'undefined') {
		ymaps.ready(YMapsInit);
	}

	var contactsMap;
	var contactsPlacemark;
	var center = GG.config.responsive ? [54.715145, 20.515787] : [54.71657, 20.511764];

	function YMapsInit() {
		contactsMap = new ymaps.Map('contacts-map', {
			center: center,
			zoom: 16,
			controls: []
		});

		contactsMap.controls.add(
			new ymaps.control.ZoomControl()
		);

		contactsPlacemark = new ymaps.Placemark([54.715145, 20.515787], {
			hintContent: 'Калининград, ул. Сергеева, 4'
		}, {
			iconImageHref: '/assets/img/pin.svg',
			iconLayout: 'default#image',
			iconImageSize: [35, 60],
			iconImageOffset: [-20, -60]
		});

		if (GG.config.responsive) {
			contactsMap.behaviors.disable('scrollZoom');
			contactsMap.behaviors.enable('multiTouch');
		}

		contactsMap.geoObjects.add(contactsPlacemark);
	}
});
